import { SubscriptionSettingsDTO } from 'components/SubscriptionSettings/api';

import { SaldomaxCurrentStatus } from '../Saldomax/types';

export const mobileSettingsMock: SubscriptionSettingsDTO = {
  settings: [
    {
      productCode: 'SG_MOBIL_OPRET_01',
      productName: 'Mobilt Bredbånd 10 GB med 4G',
      cmsRef: 'SG_MOBIL_OPRET',
      subscribed: false,
      type: 'Selectable',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [
        {
          productCode: 'EMU_ESIM_SIMKORT',
          productName: 'Oprettelse - Simkort  eSim',
          cmsRef: 'EMU_UDLEVER_SIMKORT',
          subscribed: false,
          type: 'Selectable',
          changeCode: null,
          orderId: null,
          orderDate: '0001-01-01T00:00:00',
          settings: [],
        },
        {
          productCode: 'EMU_ESIM_SIMKORT_NP',
          productName: 'Import - Simkort eSim',
          cmsRef: 'EMU_UDLEV_SIMKORT_NP',
          subscribed: false,
          type: 'Selectable',
          changeCode: null,
          orderId: null,
          orderDate: '0001-01-01T00:00:00',
          settings: [],
        },
      ],
    },
    {
      value: {
        forwardRuleAlways: {
          active: false,
          forwardNumber: '70704040',
          timeoutValue: 0,
        },
        forwardRuleBusy: {
          active: true,
          forwardNumber: '70704040',
          timeoutValue: 0,
        },
        forwardRuleNoAnswer: {
          active: true,
          forwardNumber: '70704040',
          timeoutValue: 10,
        },
        forwardRuleNoCoverage: {
          active: true,
          forwardNumber: '70704040',
          timeoutValue: 0,
        },
        validTimeoutValues: [5, 10, 15, 20, 25, 30],
      },
      productCode: 'ODIN_CODE_CALLFORWARDINGMOBILE',
      productName: 'Viderestilling',
      cmsRef: 'ODIN_CODE_CALLFORWARDINGMOBILE',
      subscribed: true,
      type: 'CallForwardingMobile',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'AP32_316_06',
      productName: 'Spærring for data via satellit',
      cmsRef: 'C3231606',
      subscribed: true,
      type: 'Selectable',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'AP03_981_00',
      productName: 'Saldomaks',
      cmsRef: 'C0398100',
      subscribed: true,
      type: 'SaldomaxMobile',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
    {
      productCode: 'ODIN_CODE_HUA_LISTED',
      productName: 'Normalt nummer',
      cmsRef: 'ODIN_CODE_HUA_LISTED',
      subscribed: true,
      type: 'UnlistedNumber',
      changeCode: null,
      orderId: null,
      orderDate: '0001-01-01T00:00:00',
      settings: [],
    },
  ],
};

export const saldomaxCurrentStatusMock: SaldomaxCurrentStatus = {
  currentUsage: 15.0,
  currentCreditLimit: 150.0,
  availableUsageLimits: [
    {
      creditLimitValue: '25',
      creditLimitDescription: '25 kr.',
    },
    {
      creditLimitValue: '50',
      creditLimitDescription: '50 kr.',
    },
    {
      creditLimitValue: '75',
      creditLimitDescription: '75 kr.',
    },
    {
      creditLimitValue: '150',
      creditLimitDescription: '150 kr.',
    },
    {
      creditLimitValue: '250',
      creditLimitDescription: '250 kr.',
    },
    {
      creditLimitValue: '500',
      creditLimitDescription: '500 kr.',
    },
    {
      creditLimitValue: '750',
      creditLimitDescription: '750 kr.',
    },
    {
      creditLimitValue: '1000',
      creditLimitDescription: '1000 kr.',
    },
    {
      creditLimitValue: '1500',
      creditLimitDescription: '1500 kr.',
    },
    {
      creditLimitValue: '3000',
      creditLimitDescription: '3000 kr.',
    },
  ],
  currentSuspensions: [],
};
